import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fillRule="evenodd"
      d="M5.15 18.938A9.72 9.72 0 0 0 12 21.75a9.72 9.72 0 0 0 6.938-2.9A9.72 9.72 0 0 0 21.75 12a9.72 9.72 0 0 0-2.9-6.939A9.72 9.72 0 0 0 12 2.25a9.72 9.72 0 0 0-6.849 2.81 1 1 0 0 0-.09.091A9.72 9.72 0 0 0 2.25 12a9.72 9.72 0 0 0 2.9 6.938M3.75 12c0-2.008.717-3.849 1.91-5.28l2.672 2.673A4.5 4.5 0 0 0 7.5 12c0 .972.308 1.872.832 2.607L5.66 17.28A8.22 8.22 0 0 1 3.75 12m2.97 6.34 2.673-2.672A4.5 4.5 0 0 0 12 16.5a4.5 4.5 0 0 0 2.607-.832l2.672 2.672A8.22 8.22 0 0 1 12 20.25a8.22 8.22 0 0 1-5.28-1.91m11.62-1.06-2.672-2.673A4.5 4.5 0 0 0 16.5 12a4.5 4.5 0 0 0-.832-2.607L18.34 6.72A8.22 8.22 0 0 1 20.25 12a8.22 8.22 0 0 1-1.91 5.28M17.28 5.66l-2.673 2.672A4.5 4.5 0 0 0 12 7.5a4.5 4.5 0 0 0-2.607.832L6.72 5.66A8.22 8.22 0 0 1 12 3.75c2.008 0 3.849.717 5.28 1.91M9 12a3 3 0 1 1 6 0 3 3 0 0 1-6 0"
      clipRule="evenodd"
    />
  </>
);

const Help = Icon('help', svgContents);

export default Help;
